module.exports = __webpack_public_path__ + "static/media/add-30s.40fe1308.svg";